import { c as _c } from "react/compiler-runtime";
import type { ButtonProps } from '@petsmart-ui/sparky';
import { Button } from '@petsmart-ui/sparky';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import React from 'react';
export function getButtonText(isActivated?: boolean, loading?: boolean): string | undefined {
  if (!loading) {
    return isActivated ? `Activated` : `Activate`;
  }
  return undefined;
}

/** ------------------------------------
 * component
 * ---------------------------------- */

type OfferCardButtonProps = ButtonProps & {
  isActivated?: boolean;
};
export function OfferCardButton(t0) {
  const $ = _c(16);
  const {
    className,
    isActivated,
    fullWidth,
    loading,
    onClick,
    size
  } = t0;
  const t1 = !fullWidth && isActivated;
  const t2 = !fullWidth && !isActivated;
  let t3;
  if ($[0] !== className || $[1] !== fullWidth || $[2] !== t1 || $[3] !== t2) {
    t3 = classNames("c-offer-card-button", className, {
      "offer-card-button-check": t1,
      "offer-card-button-plus": t2,
      "offer-card-button-full-width": fullWidth
    });
    $[0] = className;
    $[1] = fullWidth;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const componentClassName = t3;
  let t4;
  if ($[5] !== isActivated || $[6] !== loading) {
    t4 = getButtonText(isActivated, loading);
    $[5] = isActivated;
    $[6] = loading;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const text = t4;
  let t5;
  if ($[8] !== componentClassName || $[9] !== fullWidth || $[10] !== isActivated || $[11] !== loading || $[12] !== onClick || $[13] !== size || $[14] !== text) {
    t5 = fullWidth ? <Button className={componentClassName} disabled={loading} iconName={isActivated ? "check" : undefined} iconSize={size === "lg" ? "xl" : "xs"} loading={loading} onClick={onClick} fullWidth={true} size={size} text={text} variant={isActivated ? "active" : "primary"} /> : <Button className={componentClassName} circle={true} disabled={loading} iconName={isActivated ? "check" : "plus"} iconSize={isActivated ? "lg" : "md"} loading={loading} onClick={onClick} variant={isActivated ? "active" : undefined} />;
    $[8] = componentClassName;
    $[9] = fullWidth;
    $[10] = isActivated;
    $[11] = loading;
    $[12] = onClick;
    $[13] = size;
    $[14] = text;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}